// extracted by mini-css-extract-plugin
module.exports = {"box":"NewgameWrapperTopbanner_box_2T6pd"};